export default "__VITE_ASSET__BfzvWgW8__"